import { motion } from "motion/react";
import { FC, forwardRef } from "react";

import { SVG_MUI } from "@ryde/assets";
import { useRtl } from "@ryde/redux";
import { COLLAPSE_DURATION_SEC } from "@ryde/shared";

export const MotionCollapseArrow = motion.create(
  forwardRef<SVGSVGElement>((props, ref) => (
    <SVG_MUI.GroupArrowExpandSVG className="Collapse-Icon" ref={ref} />
  )),
);

type TCollapseVariant = "common" | "quaternary";

const collapseVariants: Record<
  TCollapseVariant,
  Record<string, { rotate: number }>
> = {
  common: {
    open: { rotate: -180 },
    close: { rotate: 0 },
  },
  quaternary: {
    open: { rotate: 0 },
    close: { rotate: -90 },
  },
};

interface ICollapseIconProps {
  isCollapsed: boolean;
  variant?: TCollapseVariant;
}

export const CollapseIcon: FC<ICollapseIconProps> = ({
  isCollapsed,
  variant = "common",
}) => {
  const { isRtl } = useRtl();

  const getVariants = (): Record<string, { rotate: number }> => {
    const baseVariants = collapseVariants[variant];
    if (!isRtl) {
      return baseVariants;
    }

    return {
      open: { rotate: -baseVariants.open.rotate },
      close: { rotate: -baseVariants.close.rotate },
    };
  };

  return (
    <MotionCollapseArrow
      animate={isCollapsed ? "open" : "close"}
      variants={getVariants()}
      transition={{ duration: COLLAPSE_DURATION_SEC }}
    />
  );
};
